import { OptionalLink } from '../01-core/OptionalLink';
import { Button } from '../02-atoms/Button';

export interface TeaserBubbleProps {
  /** CTA title */
  text?: string;
  /** Link on bubble */
  href?: string;
  /** Link target */
  target?: '_blank' | '_top';
  /** CTA action */
  action?: string;
  /** Show bubble on desktop (default true) */
  show_desktop?: boolean;
  /** Show bubble on mobile/tablet (default true) */
  show_mobile?: boolean;
  /** Additional class */
  className?: string;
  /** Optional click handler */
  onClick?: () => void;
}

/** A teaser bubble */
export const TeaserBubble = ({
  text,
  href,
  target,
  action,
  show_desktop,
  show_mobile,
  className,
  onClick,
}: TeaserBubbleProps) => {
  return (
    <OptionalLink
      className={[
        'teaser-bubble',
        show_desktop === false ? 'teaser-bubble--hide-desktop' : undefined,
        show_mobile === false ? 'teaser-bubble--hide-mobile' : undefined,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      href={href}
      target={target}
      onClick={onClick}
      button={true}
    >
      {text && <strong className="teaser-bubble__title">{text}</strong>}
      {action && (
        <Button
          className="teaser-bubble__cta"
          label={action}
          type="tertiary"
          size="small"
          icon="arrow_right_triangle"
          icon_after={true}
        />
      )}
    </OptionalLink>
  );
};
